import { toast } from 'react-toastify';

const ToastPromise = async ({
  promise,
  pending = 'Even geduld...',
  successRenderer,
  errorRenderer,
  autoClose = 5000,
}) => {
  const wrappedPromise = promise.catch(error => {
    // Catches the error so no runtime error occurs.
    throw error;
  });

  try {
    return await toast.promise(
      wrappedPromise,
      {
        pending,
        success: {
          render({ data }) {
            return typeof successRenderer === 'function' ? successRenderer(data) : data;
          },
          autoClose: autoClose,
        },
        error: {
          render({ data }) {
            const error = data || {};
            return typeof errorRenderer === 'function'
              ? errorRenderer(error)
              : error?.message || 'Er is een fout opgetreden';
          }
        }
      },
      {
        position: toast.POSITION.TOP_RIGHT,
        style: {
          top: '100px'
        }
      }
    );
  } catch (error) {
    return null;
  }
};

export default ToastPromise;
